var _defs, _path, _rect, _rect2, _rect3, _path2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgZip = function SvgZip(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;font-family:HelveticaNeue-CondensedBold, 'Helvetica Neue';font-size:12px;font-weight:700;}.cls-2{fill:#333;}.cls-3{fill:#76bc21;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2.61,0h30.8c1.43,0,2.6,1.16,2.6,2.6v30.8c0,1.43-1.16,2.6-2.6,2.6H2.61C1.17,35.99.01,34.83.01,33.39V2.59C.01,1.16,1.17,0,2.61,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.91,
    y: 4.9,
    width: 5.15,
    height: 3.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.91,
    y: 0,
    width: 5.15,
    height: 3.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.91,
    y: 9.81,
    width: 5.15,
    height: 3.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m12.76,23.34h-6.49c-1.37,0-2.43-1.11-2.23-2.35l2.44-6.27h6.06l2.44,6.27c.2,1.24-.85,2.35-2.23,2.35Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(15.64 30.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".Zip"))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zip.af0e78bb3466c0f61a9f98e5cc3e5734.svg";